export interface QuestionAnswerProps {
    question: string;
    answer: string| JSX.Element;
}
function QuestionAnswer({ question, answer }: QuestionAnswerProps) {
  return (
    <div style={{ fontWeight: 400, fontSize: "1.125rem" }}>
      <div>
        {question}
      </div>
      <div style={{ fontWeight: "bold" }}>
        {answer}
      </div>
    </div>
  );
}

export default QuestionAnswer;